<template>
  <div>
    <span v-if="listOperations.some(func => func.name.includes('task_plan'))">
      <el-button v-if="showTaskList=='current'" type="success" @click="currentTask">计划任务</el-button>
      <el-button v-else type="primary" @click="currentTask">计划任务</el-button>
    </span>

    <span v-if="listOperations.some(func => func.name.includes('task_history'))">
       <el-button v-if="showTaskList=='history'"
                  type="success" style="margin-left: 10px;" @click="historyTask">历史任务
    </el-button>
    <el-button v-else type="primary" style="margin-left: 10px" @click="historyTask">历史任务</el-button>
    </span>


    <el-table :data="taskData" v-if="showTaskList=='current'"
              row-key="id" :load="loadTaskList"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column align="center" label="" prop="docker" width="60px">
        <template v-slot="{row}">
          <div v-if="row.docker && row.moduleMode!=0" style="width:40px;height: 65px;">
            <img src="@/assets/docker.png" style="
                   margin-bottom: -28px;width:25px;height: 25px;">
          </div>
          <div v-else-if="!row.docker && row.moduleMode==0" style="width:40px;height: 65px;">
            <img src="@/assets/butel.png" style="
                   width:40px;height: 40px;margin-top: 13px">
          </div>
          <div v-else style="width:40px;height: 65px;">
            <img src="@/assets/docker.png" style="vertical-align: center;width:25px;height: 25px;">
            <img src="@/assets/butel.png" style="vertical-align: center;
                   width:40px;height: 40px;">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="" width="30px" prop="onlineInstanceId">
        <template v-slot="{row}">
          <div v-if="row.onlineInstanceId && row.onlineInstanceId != 0 && row.onlineInstanceId==row.id">
            <img src="@/assets/run.gif" style="width: 25px;height: 25px;margin-top: 10px">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实例ID_服务ID" width="120px">
        <template v-slot="{row}">
          <!--          {{getVsersionServerId(row)}}-->
          {{ row.instanceId.id }}_{{ row.instanceId.service.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" property="startStatus" label="启动状态" width="80px">
        <template v-slot="{row}">
          <i
            class="el-icon-sunny statusIcon"
            title="已启动"
            style="color:#67C23A;"
            v-if="row.instanceId.service.status.operation.start == 1 &&
                    row.instanceId.service.status.operation.stop != 2"
          ></i>
          <i
            class="el-icon-sunset statusIcon"
            title="已停止"
            style="color:rgb(247, 210, 103);"
            v-if="row.instanceId.service.status.operation.stop == 1
                    || (row.instanceId.service.status.operation.install == 1
                        && row.instanceId.service.status.operation.stop == -1
                        && row.instanceId.service.status.operation.start == -1)"
          ></i>
          <i
            class="el-icon-lightning statusIcon"
            :title="row.instanceId.service.status.operation.start == 2 ?'启动失败':'停止失败'"
            style="color:rgb(245, 108, 108);"
            v-if="row.instanceId.service.status.operation.start == 2
              || row.instanceId.service.status.operation.stop == 2"
          ></i>
          <i
            class="el-icon-loading statusIcon"
            :title="row.instanceId.service.status.operation.start == 0?'正在启动':'正在停止'"
            style="color:#66b1ff;"
            v-if="row.instanceId.service.status.operation.start== 0
              || row.instanceId.service.status.operation.stop == 0"
          ></i>
        </template>
      </el-table-column>
      <el-table-column align="center" property="heartStatus" label="心跳状态" width="80px">
        <template v-slot="{row}">
          <img
            src="@/assets/u881.png"
            style="vertical-align: middle;"
            v-if="row.instanceId.service.status.operation.heartbeat == 1"/>
          <img src="@/assets/u883.png" style="vertical-align: middle;" v-else/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="别名">
        <template v-slot="{row}">
          {{ row.instanceId.alias }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="设备名称">
        <template v-slot="{row}">
          {{ row.instanceId.deviceName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="模块类型">
        <template v-slot="{row}">
          {{ row.instanceId.moduleType }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="模块版本">
        <template v-slot="{row}">
          {{ row.instanceId.moduleVersion }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态描述" :formatter="taskStatusDesc" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="结果描述" show-overflow-tooltip>
        <template v-slot="{row}">
          {{ row.instanceId.service.status.description }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务类型">
        <template v-slot="{row}">
          <span v-if="row.taskType=='restart'">重启</span>
          <span v-else-if="row.taskType=='update'">更新</span>
          <span v-else>启动</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="300">
        <template v-slot="{row}">
          <div v-if="row.execTime">
            <el-button size="mini" type="primary" @click="editTask(row)"
                       v-if="listOperations.some(func => func.name.includes('task_plan_edit'))">编辑</el-button>
            <el-button size="mini" type="danger" @click="stopTask(row)"
                       v-if="row.isPause==0 && listOperations.some(func => func.name.includes('task_plan_stop'))">终止任务
            </el-button>
            <el-button size="mini" type="primary" @click="stopTask(row)"
                       v-if="row.isPause==1 && listOperations.some(func => func.name.includes('task_plan_start'))">开启任务
            </el-button>
            <el-button size="mini" type="primary" @click="taskDetail(row)"
                       v-if="listOperations.some(func => func.name.includes('task_plan_detail'))">任务详情</el-button>
            <el-button size="mini" type="danger" style="margin-top: 5px "
                       @click="delConfirm(row.id)"
                       v-if="listOperations.some(func => func.name.includes('task_plan_del'))">删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="historyTaskData" v-if="showTaskList=='history'"
              row-key="id" :load="loadHistoryList"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column align="center" label="" prop="docker" width="60px">
        <template v-slot="{row}">
          <div v-if="row.docker && row.moduleMode!=0" style="width:40px;height: 65px;">
            <img src="@/assets/docker.png" style="
                   margin-bottom: -28px;width:25px;height: 25px;">
          </div>
          <div v-else-if="!row.docker && row.moduleMode==0" style="width:40px;height: 65px;">
            <img src="@/assets/butel.png" style="
                   width:40px;height: 40px;margin-top: 13px">
          </div>
          <div v-else style="width:40px;height: 65px;">
            <img src="@/assets/docker.png" style="vertical-align: center;width:25px;height: 25px;">
            <img src="@/assets/butel.png" style="vertical-align: center;
                   width:40px;height: 40px;">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="" width="30px" prop="onlineInstanceId">
        <template v-slot="{row}">
          <div v-if="row.onlineInstanceId && row.onlineInstanceId != 0 && row.onlineInstanceId==row.id">
            <img src="@/assets/run.gif" style="width: 25px;height: 25px;margin-top: 10px">
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="实例ID_服务ID" width="120px">
        <template v-slot="{row}">
          {{ row.instanceId.id }}_{{ row.instanceId.service.id }}
        </template>
      </el-table-column>
      <el-table-column align="center" property="startStatus" label="启动状态" width="80px">
        <template v-slot="{row}">
          <i
            class="el-icon-sunny statusIcon"
            title="已启动"
            style="color:#67C23A;"
            v-if="row.instanceId.service.status.operation.start == 1 &&
                    row.instanceId.service.status.operation.stop != 2"
          ></i>
          <i
            class="el-icon-sunset statusIcon"
            title="已停止"
            style="color:rgb(247, 210, 103);"
            v-if="row.instanceId.service.status.operation.stop == 1
                    || (row.instanceId.service.status.operation.install == 1
                        && row.instanceId.service.status.operation.stop == -1
                        && row.instanceId.service.status.operation.start == -1)"
          ></i>
          <i
            class="el-icon-lightning statusIcon"
            :title="row.instanceId.service.status.operation.start == 2 ?'启动失败':'停止失败'"
            style="color:rgb(245, 108, 108);"
            v-if="row.instanceId.service.status.operation.start == 2
              || row.instanceId.service.status.operation.stop == 2"
          ></i>
          <i
            class="el-icon-loading statusIcon"
            :title="row.instanceId.service.status.operation.start == 0?'正在启动':'正在停止'"
            style="color:#66b1ff;"
            v-if="row.instanceId.service.status.operation.start== 0
              || row.instanceId.service.status.operation.stop == 0"
          ></i>
        </template>
      </el-table-column>
      <el-table-column align="center" property="heartStatus" label="心跳状态" width="80px">
        <template v-slot="{row}">
          <img
            src="@/assets/u881.png"
            style="vertical-align: middle;"
            v-if="row.instanceId.service.status.operation.heartbeat == 1"/>
          <img src="@/assets/u883.png" style="vertical-align: middle;" v-else/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="别名">
        <template v-slot="{row}">
          {{ row.instanceId.alias }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="设备名称">
        <template v-slot="{row}">
          {{ row.instanceId.deviceName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="模块类型">
        <template v-slot="{row}">
          {{ row.instanceId.moduleType }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="模块版本">
        <template v-slot="{row}">
          {{ row.instanceId.moduleVersion }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态描述" :formatter="taskStatusDesc" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="结果描述" show-overflow-tooltip>
        <template v-slot="{row}">
          {{ row.instanceId.service.status.description }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="任务类型">
        <template v-slot="{row}">
          <span v-if="row.taskType=='restart'">重启</span>
          <span v-if="row.taskType=='update'">更新</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="170">
        <template v-slot="{row}">
          <div v-if="row.execTime">
            <el-button size="mini" type="danger" style="margin-top: 5px "
                       @click="delHistory(row.id)"
                       v-if="listOperations.some(func => func.name.includes('task_history_del'))">删除
            </el-button>
            <el-button size="mini" type="primary" @click="taskDetail(row)"
                       v-if="listOperations.some(func => func.name.includes('task_history_detail'))">任务详情</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="taskTitle" :visible.sync="taskView">
      <el-form :model="taskForm">
        <el-form-item label="ID">
          <el-button type="text" style="margin-left: 50px">{{ taskInstanceId }}</el-button>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-button type="text" v-if="taskType=='restart'" style="margin-left: 9px">重启</el-button>
          <el-button type="text" v-if="taskType=='update'" style="margin-left: 9px">更新</el-button>
        </el-form-item>
        <el-form-item label="执行时间">
          <el-date-picker
            :disabled="detail"
            value-format="yyyy-MM-dd HH:mm"
            v-model="execTime"
            type="datetime"
            placeholder="选择执行时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配置文件">
          <el-button type="primary" size="small" :disabled="ban" @click="chooseFile">选择配置文件</el-button>
          <span v-if="showTaskFile">
<el-table :data="taskFileList" style="width: 100%">
      <el-table-column prop="configName" label="文件名称" width="180"></el-table-column>
      <el-table-column prop="location" label="路径" width="180"></el-table-column>
    </el-table>
          </span>
        </el-form-item>
        <el-form-item v-if="detail" label="描述">
          <div v-html="reason" style="margin-left: 60px"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveEditTask">确 定</el-button>
        <el-button @click="taskView = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="配置文件列表" :visible.sync="ListView">
      <el-table :data="fileListData" ref="taskFileTable"
                @selection-change="chooseTaskFile">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column align="center" prop="name" label="文件名称"></el-table-column>
        <el-table-column align="center" prop="location" label="路径"></el-table-column>
        <el-table-column align="center" prop="version" label="版本号"></el-table-column>
        <el-table-column align="center" prop="function" label="描述"></el-table-column>
        <el-table-column align="center" prop="creator" label="创建者"></el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="saveSelectedFile">确 定</el-button>
        <el-button @click="ListView = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>

<script>
import {Loading} from "element-ui";
import {mapMutations, mapState} from "vuex";

export default {
  name: "TaskPlan",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalElement: 0,
      taskData: [],
      historyTaskData: [],
      taskFileList: [],
      fileListData: [],
      taskView: false,
      taskForm: {},
      taskInstanceId: "",
      id: "",
      taskType: "",
      docker: "",
      execTime: null,
      isPause: 0,
      detail: false,
      ListView: false,
      showTaskFile: false,
      ban: false,
      taskTitle: "",
      taskmoduleName: "",
      taskmoduleVersion: "",
      selectedFile: "",
      showTaskList: "current",
      timer: null,
      reason: []
    }
  },
  created() {
    this.getListOperations('monitor/taskplan');
    if (!this.currentMenu) {
      return
    }
    this.getTaskList();
    this.refresh()
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    // 操作按钮是否显示
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (!childName) {
          return btn.length > 0
        } else {
          return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
        }

      }
    },
  },
  methods: {
    ...mapMutations(['getListOperations']),
    loadTaskList(tree, treeNode, resolve) {
      setTimeout(() => {
        resolve(
          this.getTaskList()
        )
      }, 1000)
    },
    loadHistoryList(tree, treeNode, resolve) {
      setTimeout(() => {
        resolve(
          this.getHistoryTaskList()
        )
      }, 1000)
    },
    delConfirm(id) {
      this.$confirm('您确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delTask(id);
        this.getTaskList();
      }).catch(() => {

      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.showTaskList == 'history') {
        this.getHistoryTaskList()
      } else if (this.showTaskList == 'current') {
        this.getTaskList()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.showTaskList == 'history') {
        this.getHistoryTaskList()
      } else if (this.showTaskList == 'current') {
        this.getTaskList()
      }
    },
    delHistory(id) {
      let url = this.baseUrl3 + 'deploy/timerTask/deleteTaskForever/' + id;
      let _this = this;
      this.$axios.post(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.getHistoryTaskList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    refresh() {
      if (this.timer != null) {
        return;
      }
      this.timer = setInterval(() => {
        this.getTaskList();
      }, 300000);
    },
    getHistoryTaskList() {
      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/findHistoryTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            let taskInfos = data.taskInfos;
            if (data.taskInfos && data.taskInfos.length > 0) {
              for (let i = 0; i < taskInfos.length; i++) {
                if (taskInfos[i].children) {
                  let childrenData = [];
                  taskInfos[i].children.forEach(e => {
                    let obj = {
                      id: e.id,
                      instanceId: e
                    };
                    childrenData.push(obj)
                  });
                  taskInfos[i].children = childrenData
                }
              }
              this.historyTaskData = taskInfos;
              this.totalElement = data.total;
            } else {
              this.historyTaskData = [];
              this.totalElement = 0;
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    currentTask() {
      this.showTaskList = "current";
      this.currentPage = 1;
      this.pageSize = 10;
      this.getTaskList();
    },
    historyTask() {
      this.showTaskList = "history";
      this.currentPage = 1;
      this.pageSize = 10;
      this.getHistoryTaskList();
    },
    chooseTaskFile(val) {
      this.taskFileList = [];
      let arr = [];
      arr = this.$refs["taskFileTable"].selection;
      arr.forEach(e => {
        this.taskFileList.push({
          location: e.location+"",
          configName: e.name,
        })
      });
      this.selectedFile = JSON.stringify(this.taskFileList);
    },
    getAllConfigList() {
      if (!this.taskmoduleName || !this.taskmoduleVersion) {
        return;
      }
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      this.$axios
        .get(
          this.moduleUrl +
          "config/get/listByNameAndVersion/" +
          this.taskmoduleName +
          "/" +
          this.taskmoduleVersion
        )
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            data.forEach(d => {
              if (!d.location) {
                d.location = null
              }
              if (d.name.indexOf(".service") != -1) {
                d.name = this.serviceName + ".service";
              }
            });
            this.fileListData = data;
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    getDockerConfigList() {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.fileListData = [];
      let url = this.baseUrl3 + "config/cat/all/" + this.taskInstanceId;
      this.$axios.get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.length > 0) {
              data.forEach(d => {
                if (!d.location) {
                  d.location = null
                }
              });
              this.fileListData = data;
            } else {
              this.$message({showClose: true, message: "当前模块没有配置文件", type: "warn"});
            }

          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        });
    },
    saveSelectedFile() {
      this.showTaskFile = true;
      this.ListView = false;
    },
    chooseFile() {
      this.ListView = true;
      if (this.docker) {
        this.getDockerConfigList()
      } else {
        this.getAllConfigList()
      }

    },
    getTaskList() {
      let data = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/findTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            let taskInfos = data.taskInfos;
            if (data.taskInfos && data.taskInfos.length > 0) {
              for (let i = 0; i < taskInfos.length; i++) {
                if (taskInfos[i].children) {
                  let childrenData = []
                  taskInfos[i].children.forEach(e => {
                    let obj = {
                      id: e.id,
                      instanceId: e
                    }
                    childrenData.push(obj)
                  })
                  taskInfos[i].children = childrenData
                }
              }
              this.taskData = taskInfos;
              this.totalElement = data.total;
            } else {
              this.taskData = [];
              this.totalElement = 0;
            }

          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    stopTask(row) {
      if (row.isPause == 0) {
        this.isPause = 1
      } else {
        this.isPause = 0
      }
      let data = {
        id: row.id,
        isPause: this.isPause,
        instanceId: row.instanceId.id,
        newInstanceId: row.children ? row.children[0].instanceId.id : 0,
        taskType: row.taskType,
        execTime: row.execTime,
        config: row.config
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/updateTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.taskView = false;
            this.getTaskList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editTask(row) {
      if (row.config) {
        this.showTaskFile = true;
        this.taskFileList = JSON.parse(row.config);
      } else {
        this.showTaskFile = false
      }
      if (row.children && row.children.length > 0) {

        this.newInstanceId = row.children[0].instanceId.id
      } else {
        this.newInstanceId = 0
      }
      this.taskmoduleName = row.instanceId.moduleType;
      this.taskmoduleVersion = row.instanceId.moduleVersion;
      this.taskTitle = "编辑";
      this.id = row.id;
      this.taskView = true;
      this.detail = false;
      this.ban = false;
      this.docker = row.instanceId.isDocker;
      this.taskInstanceId = row.instanceId.id;
      this.taskType = row.taskType;
      this.execTime = row.execTime;
    },
    saveEditTask() {
      let data = {
        id: this.id,
        instanceId: this.taskInstanceId,
        newInstanceId: this.newInstanceId,
        taskType: this.taskType,
        execTime: this.execTime,
        config: this.selectedFile
      };
      this.currentTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
      let currentT = new Date(this.currentTime).getTime() / 1000;
      let execT = new Date(this.execTime).getTime() / 1000;
      if (execT < currentT + 600) {
        this.$message.error('执行时间需晚于当前时间十分钟！');
        return
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/updateTask', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.taskView = false;
            this.getTaskList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    delTask(id) {
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'deploy/timerTask/deleteTask/' + id)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.getTaskList();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    taskDetail(row) {
      if (row.config) {
        this.showTaskFile = true;
        this.taskFileList = JSON.parse(row.config);
      } else {
        this.showTaskFile = false
      }
      this.taskTitle = "任务详情";
      this.ban = true;
      this.detail = true;
      this.taskView = true;
      this.taskInstanceId = row.instanceId.id;
      this.taskType = row.taskType;
      this.execTime = row.execTime;
      // this.reason = row.reason;
      let arr = []
      arr = row.reason.split(";");
      this.reason = arr.join("；,").replace(/\,/g, '</br>');

    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style scoped>
.statusIcon {
  font-size: 30px;
}
</style>
